import React from "react"

import { JobPosting } from "@/types/jobPosting"

import OrientationContent from "../orientation/OrientationContent"
import TrialBlocksContentWithProvider from "../trial-blocks/TrialBlocksContentWithProvider"
import VehicleBookingContent from "../vehicle/VehicleBookingContent"

interface ExternalContentFrameProps {
  contentType: "trial" | "orientation" | "vehicle"
  jobPostings: JobPosting[]
}

const ExternalContentFrame: React.FC<ExternalContentFrameProps> = ({
  contentType,
  jobPostings,
}) => {
  // Directly render the appropriate component content without the DashboardLayout
  return (
    <div className="bg-white p-6 rounded-lg shadow-sm">
      {contentType === "trial" && <TrialBlocksContentWithProvider />}
      {contentType === "orientation" && <OrientationContent jobPostings={jobPostings} />}
      {contentType === "vehicle" && <VehicleBookingContent jobPostings={jobPostings} />}
    </div>
  )
}

export default ExternalContentFrame
